import y from "./index216.mjs";
import A from "./index215.mjs";
import { getContrastRatio as v, lighten as I, darken as P } from "./index218.mjs";
import u from "./index428.mjs";
import R from "./index429.mjs";
import s from "./index430.mjs";
import c from "./index431.mjs";
import l from "./index432.mjs";
import d from "./index433.mjs";
import m from "./index434.mjs";
import g from "./index435.mjs";
import S from "./index244.mjs";
import w from "./index234.mjs";
const U = ["mode", "contrastThreshold", "tonalOffset"], T = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: u.white,
    default: u.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, b = {
  text: {
    primary: u.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: u.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function D(r, e, f, o) {
  const p = o.light || o, h = o.dark || o * 1.5;
  r[e] || (r.hasOwnProperty(f) ? r[e] = r[f] : e === "light" ? r.light = I(r.main, p) : e === "dark" && (r.dark = P(r.main, h)));
}
function V(r = "light") {
  return r === "dark" ? {
    main: d[200],
    light: d[50],
    dark: d[400]
  } : {
    main: d[700],
    light: d[400],
    dark: d[800]
  };
}
function W(r = "light") {
  return r === "dark" ? {
    main: s[200],
    light: s[50],
    dark: s[400]
  } : {
    main: s[500],
    light: s[300],
    dark: s[700]
  };
}
function j(r = "light") {
  return r === "dark" ? {
    main: c[500],
    light: c[300],
    dark: c[700]
  } : {
    main: c[700],
    light: c[400],
    dark: c[800]
  };
}
function B(r = "light") {
  return r === "dark" ? {
    main: m[400],
    light: m[300],
    dark: m[700]
  } : {
    main: m[700],
    light: m[500],
    dark: m[900]
  };
}
function L(r = "light") {
  return r === "dark" ? {
    main: g[400],
    light: g[300],
    dark: g[700]
  } : {
    main: g[800],
    light: g[500],
    dark: g[900]
  };
}
function G(r = "light") {
  return r === "dark" ? {
    main: l[400],
    light: l[300],
    dark: l[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: l[500],
    dark: l[900]
  };
}
function or(r) {
  const {
    mode: e = "light",
    contrastThreshold: f = 3,
    tonalOffset: o = 0.2
  } = r, p = A(r, U), h = r.primary || V(e), E = r.secondary || W(e), x = r.error || j(e), $ = r.info || B(e), N = r.success || L(e), _ = r.warning || G(e);
  function k(t) {
    const a = v(t, b.text.primary) >= f ? b.text.primary : T.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const n = v(t, a);
      n < 3 && console.error([`MUI: The contrast ratio of ${n}:1 for ${a} on ${t}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return a;
  }
  const i = ({
    color: t,
    name: a,
    mainShade: n = 500,
    lightShade: C = 300,
    darkShade: M = 700
  }) => {
    if (t = y({}, t), !t.main && t[n] && (t.main = t[n]), !t.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${a ? ` (${a})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${n}\` property.` : w(11, a ? ` (${a})` : "", n));
    if (typeof t.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${a ? ` (${a})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(t.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : w(12, a ? ` (${a})` : "", JSON.stringify(t.main)));
    return D(t, "light", C, o), D(t, "dark", M, o), t.contrastText || (t.contrastText = k(t.main)), t;
  }, O = {
    dark: b,
    light: T
  };
  return process.env.NODE_ENV !== "production" && (O[e] || console.error(`MUI: The palette mode \`${e}\` is not supported.`)), S(y({
    // A collection of common colors.
    common: y({}, u),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: e,
    // The colors used to represent primary interface elements for a user.
    primary: i({
      color: h,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: i({
      color: E,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: i({
      color: x,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: i({
      color: _,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: i({
      color: $,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: i({
      color: N,
      name: "success"
    }),
    // The grey colors.
    grey: R,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: f,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: k,
    // Generate a rich color object.
    augmentColor: i,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: o
  }, O[e]), p);
}
export {
  b as dark,
  or as default,
  T as light
};
